<template>
	<div>
		<ul v-if="showdates" class="nav navbar-nav dynvibeDateRangePickerNav" :id="'rangePickerNav-' + this.type">
			<li>
				<div :class="type === 'classic' ? 'dateFrom' : 'dateFromCompare'">
					FROM
					<br />
					<span>{{ allDates ? "" : dateStart }}</span>
				</div>
			</li>
			<li>
				<div :class="type === 'classic' ? 'dateTo' : 'dateToCompare'">
					TO
					<br />
					<span>{{ allDates ? "" : dateEnd }}</span>
				</div>
			</li>
		</ul>
		<input :id="'dynvibeDateRangePicker-' + type" name="daterangepicker" style="display: none" />
	</div>
</template>

<script>
import daterangepicker from "daterangepicker";
import "daterangepicker/daterangepicker.css";
export default {
	name: "datepicker",
	emits: ["datepickercreated", "changedate"],
	props: {
		datefrom: {
			type: String,
			default: () => {
				return "";
			},
		},
		dateto: {
			type: String,
			default: () => {
				return "";
			},
		},
		type: {
			type: String,
			default: () => "",
		}, // "classic' or 'comparison', or 'following' or 'graph'
		showdates: {
			type: Boolean,
			default: false,
		},
		updateParameters: {
			type: Boolean,
			default: true,
		},
		displayAllButton: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			dateStart: "",
			dateEnd: "",
			allDates: false,
			ranges: {},
		};
	},
	created() {
		console.log(daterangepicker);
		this.ranges = {
			Today: [this.$moment(), this.$moment()],
			Yesterday: [this.$moment().subtract(1, "days"), this.$moment().subtract(1, "days")],
			"Last Week": [this.$moment().subtract(6, "days"), this.$moment()],
			"Last Month": [this.$moment().subtract(1, "month"), this.$moment()],
			"Last 3 Months": [this.$moment().subtract(3, "month"), this.$moment()],
			"Last 6 Months": [this.$moment().subtract(6, "month"), this.$moment()],
			"Last Year": [this.$moment().subtract(1, "years"), this.$moment()],
		};
		if (this.displayAllButton) {
			this.ranges["All"] = [this.$moment().subtract(20, "years"), this.$moment()];
		}
	},
	mounted() {
		this.dateStart = this.datefrom;
		this.dateEnd = this.dateto;
		console.log(this.dateStart);

		let interval = Math.abs(new Date(this.datefrom) - new Date(this.dateto));
		interval = interval / (1000 * 3600 * 24); // in days
		if (interval >= 365 * 20) {
			// 20 years
			this.dateStart = null;
			this.dateEnd = null;
		}
		if (this.type === "following") {
			window.$(".followingComparison").bind("click", () => {
				window.$("#dynvibeDateRangePicker-" + this.type).trigger("click");
			});
		} else if (this.type === "comparison") {
			window
				.$(".dateComparison")
				.off("click")
				.on("click", () => {
					window.$("#dynvibeDateRangePicker-" + this.type).trigger("click");
				});
		} else if (this.type === "graph") {
			window
				.$(".dateFromCompare, .dateToCompare")
				.unbind("click")
				.bind("click", () => {
					window.$("#dynvibeDateRangePicker-" + this.type).trigger("click");
				});
		} else {
			window
				.$(".dateFrom, .dateTo")
				.unbind("click")
				.bind("click", () => {
					window.$("#dynvibeDateRangePicker-" + this.type).trigger("click");
				});
		}
		this.checkInterval();

		window
			.$("#dynvibeDateRangePicker-" + this.type)
			.unbind("show.daterangepicker showCalendar.daterangepicker")
			.bind("show.daterangepicker showCalendar.daterangepicker", () => {
				let $placement = "";
				if (this.type === "classic" || this.type === "graph") {
					$placement = window.$(".dateFrom");
				} else if (this.type === "comparison") {
					$placement = window.$("div.dynvibeButtonExportDate.dateComparison");
				} else if (this.type === "following") {
					$placement = window.$("div.dynvibeButtonExportFollowing.followingComparison");
				}
				let top = $placement.offset().top + $placement.outerHeight();
				let left = $placement.offset().left;
				window.$(".daterangepicker").css({ top: top, left: left });
			});

		// SHOW
		window.$("#dynvibeDateRangePicker-" + this.type).bind("show.daterangepicker", () => {
			if (this.dateStart && this.dateEnd) {
				let dataRangePickerData = window.$("#dynvibeDateRangePicker-" + this.type).data("daterangepicker");
				dataRangePickerData.setStartDate(this.dateStart);
				dataRangePickerData.setEndDate(this.dateEnd);
				dataRangePickerData.updateCalendars();
			}
		});

		// APPLY
		window
			.$("#dynvibeDateRangePicker-" + this.type)
			.unbind("apply.daterangepicker")
			.bind("apply.daterangepicker", () => {
				let dataRangePickerData = window.$("#dynvibeDateRangePicker-" + this.type).data("daterangepicker");
				let valFrom = dataRangePickerData.startDate.format("YYYY-MM-DD");
				let valTo = dataRangePickerData.endDate.format("YYYY-MM-DD");

				if (this.type === "classic") {
					let dateToday = new Date();
					let outputDate = dateToday.getFullYear() - 20;

					if (parseInt(outputDate) == parseInt(valFrom.substr(0, 4))) {
						this.dateStart = null;
						this.dateEnd = null;
					} else {
						this.dateStart = valFrom;
						this.dateEnd = valTo;
					}

					if (this.updateParameters) {
						this.$store.dispatch("addToParameters", {
							key: "date",
							value: { gte: valFrom, lte: valTo },
						});
					} else {
						this.$emit("changedate", { gte: valFrom, lte: valTo });
					}
				} else {
					this.dateStart = valFrom;
					this.dateEnd = valTo;
					if (this.type === "graph") {
						this.$emit("changedate", { gte: valFrom, lte: valTo });
					} else {
						this.$store.dispatch("setDateCompare", {
							gte: valFrom,
							lte: valTo,
						});
						this.$emit("changedate");
					}
				}
				this.checkInterval();
			});

		window.$("#dynvibeDateRangePicker-" + this.type).daterangepicker({
			alwaysShowCalendars: true,
			showCustomRangeLabel: false,
			buttonClasses: ["dynvibeDateRangePickerButton"],
			cancelClass: "btn-danger",
			locale: {
				format: "YYYY-MM-DD",
				monthNames: [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
					"August",
					"September",
					"October",
					"November",
					"December",
				],
			},
			ranges: this.ranges,
		});
		this.$emit("datepickercreated");
	},
	methods: {
		checkInterval() {
			if (this.dateStart == "" && this.dateEnd == "") {
				this.allDates = true;
			} else {
				this.allDates = false;
			}
		},
		setDates(start, end) {
			this.dateStart = start;
			this.dateEnd = end;
			let dataRangePickerData = window.$("#dynvibeDateRangePicker-" + this.type).data("daterangepicker");
			dataRangePickerData.setStartDate(this.$moment().format("YYYY-MM-DD"));
			dataRangePickerData.setEndDate(this.$moment().format("YYYY-MM-DD"));
			dataRangePickerData.updateCalendars();
			this.checkInterval();
		},
		// openDateRangePicker() {
		// 	console.log(this.dateFrom);
		// 	if (this.dateFrom && this.dateTo) {
		// 		let dataRangePickerData = window.$("#dynvibeDateRangePicker-" + this.type).data("daterangepicker");
		// 		dataRangePickerData = window.$("#dynvibeDateRangePicker").data("daterangepicker");
		// 		dataRangePickerData.setStartDate(this.dateFrom);
		// 		dataRangePickerData.setEndDate(this.dateTo);
		// 		dataRangePickerData.updateCalendars();
		// 	}
		// },
	},
};
</script>

<style>
.dynvibeDateRangePickerNav {
	display: flex;
	margin-left: 20px;
	min-width: 300px;
}

.dateFrom,
.dateTo,
.dateFromCompare,
.dateToCompare {
	cursor: pointer;
	text-align: center;
	padding: 5px 20px;
	background-color: #fff;
	font-weight: 700;
	color: #cacaca;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}

.dynvibeDateRangePickerNav:hover .dateFrom,
.dynvibeDateRangePickerNav:hover .dateTo,
.dynvibeDateRangePickerNav:hover .dateFromCompare,
.dynvibeDateRangePickerNav:hover .dateToCompare {
	box-shadow: 0 0 5px #33d1cd;
}

.dateFrom span,
.dateTo span,
.dateFromCompare span,
.dateToCompare span {
	color: #747474;
}

#dynvibeDateRangePicker {
	min-width: 200px;
	margin-left: 25px;
	padding: 10px;
	cursor: pointer;
	text-align: center;
}

.daterangepicker {
	padding: 10px;
	border: none;
	border-radius: 0px;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}

.daterangepicker thead tr:first-child {
	background-color: #23056b;
	color: #fff;
}

.daterangepicker thead tr:first-child th {
	text-transform: uppercase;
	border-radius: 0px;
}

.daterangepicker td {
	padding: 7px !important;
	border-radius: 0px;
}

.daterangepicker td.active {
	background-color: #ef402e !important;
}

.daterangepicker td.in-range,
.daterangepicker td.off.in-range {
	background-color: rgba(239, 64, 46, 0.2);
}

.daterangepicker .prev,
.daterangepicker .next {
	color: #9a8cbb;
}

.daterangepicker .prev:hover,
.daterangepicker .next:hover {
	background-color: #23056b !important;
	color: #fff;
}

.daterangepicker .daterangepicker_input > input {
	border-radius: 0px !important;
	box-shadow: none;
}

.daterangepicker .daterangepicker_input > input.active {
	border: 1px solid #33d1cd;
}

.daterangepicker .ranges {
	float: right !important;
}

.daterangepicker .ranges [data-range-key] {
	border: 1px solid #33d1cd;
	border-radius: 0px;
	background-color: #fff;
	color: #33d1cd;
	text-transform: uppercase;
	font-weight: 600;
}

.daterangepicker .ranges [data-range-key]:hover,
.daterangepicker .ranges [data-range-key].active {
	background-color: #33d1cd;
	color: #fff;
}

.daterangepicker .range_inputs {
	text-align: right;
}

.dynvibeDateRangePickerButton {
	font-size: 14px;
	font-weight: 600;
	padding: 10px 15px;
	border: none;
	text-transform: uppercase;
}

.dynvibeDateRangePickerButtonCancel {
	margin-left: 10px;
}

ul li {
	display: list-item;
}

#rangePickerNav-graph {
	margin-left: 0;
	justify-content: center;
	width: 100%;
}

#rangePickerNav-graph li {
	width: 25%;
}

#rangePickerNav-classic li {
	width: 50%;
}

@media (max-width: 768px) {
	.dynvibeDateRangePickerNav {
		display: none;
	}
}
</style>
